module.exports = __webpack_public_path__ + "img/other_pay_easywallet2.78f7c38d.svg";